import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createTheme, ThemeProvider } from "@mui/material";
// @ts-expect-error
import { ProSidebarProvider } from "react-pro-sidebar";
import { Provider } from "react-redux";
import store from "./store/store";

if (process.env.NODE_ENV === 'production') {
  console.log = function () { };
  console.warn = function () { };
  console.error = function () { }; // optional: disable warnings/errors too
}

const theme = createTheme({
  palette: {
    primary: {
      light: "#478F96",
      main: "#478F96",
      dark: "#478F96",
      contrastText: "#FFFFFF",
    },
    secondary: {
      light: "#FFFFFF",
      main: "#FFFFFF",
      dark: "#FFFFFF",
      contrastText: "#478F96",
    },
  },
  typography: {
    allVariants: {
      color: "#263238"
    }
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ProSidebarProvider>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <App />
      </Provider>
    </ThemeProvider>
  </ProSidebarProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
